import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';

const DisableContext = createContext(true);

export const DisableProvider = ({ children }) => {
  const [disabled, setDisabled] = useState(false);
  const [activeForm, setActiveForm] = useState(null);
  return (
    <DisableContext.Provider value={{ disabled, setDisabled, activeForm, setActiveForm }}>
      {children}
    </DisableContext.Provider>
  );
};

export const useDisabledState = () => {
  const { disabled, setDisabled, activeForm, setActiveForm } = useContext(DisableContext);
  return { disabled, setDisabled, activeForm, setActiveForm };
};

export const withDisabledState = (Component) => (props) => {
  const { disabled, setDisabled } = useContext(DisableContext);
  return <Component {...props} disabled={disabled} setDisabled={setDisabled} />;
};

DisableProvider.propTypes = {
  children: PropTypes.node.isRequired
};
